import { useMemo } from "react"
import { useParams } from "next/navigation"
import { useTranscriptionContextStore } from "@/stores/use-transcription-context-store"

import { useFetchBook } from "@/hooks/api/books/queries"
import { useFetchCurrentUser } from "@/hooks/api/users/queries"

export function useTranscriptionKeywords(): string[] {
  const { entityKeywords } = useTranscriptionContextStore()
  const { data: currentUser } = useFetchCurrentUser()
  const params = useParams()
  const bookId = params?.bookId as string | undefined
  const { data: book } = useFetchBook(bookId ?? "")

  return useMemo(() => {
    const keywords: string[] = []

    if (currentUser?.full_name) keywords.push(currentUser.full_name)
    if (currentUser?.first_name) keywords.push(currentUser.first_name)
    if (currentUser?.company?.name) keywords.push(currentUser.company.name)

    if (book?.name) keywords.push(book.name)
    if (book?.principal?.full_name) keywords.push(book.principal.full_name)

    keywords.push(...entityKeywords)

    return Array.from(new Set(keywords.filter(Boolean)))
  }, [entityKeywords, currentUser, book])
}
